<template>
  <Container
    :class="$style.container"
  >
    <GettingStartedPanel
      :itemType="$options.itemType"
      :visible="true"
    />

    <CardCta
      :buttonProps="{ 'type': 'primary' }"
      :class="$style.card"
      :ctaText="$options.pkiGettingStartedCard.buttonLabel"
      footerAlignment="right"
    >
      <template v-slot:header>
        <HeadingSmall
          :class="$style.cardHeading"
        >
          {{ $options.pkiGettingStartedCard.title }}
        </HeadingSmall>
      </template>
      <template v-slot:body>
        <ParagraphBody>
          {{ $options.pkiGettingStartedCard.text }}
        </ParagraphBody>
        <ParagraphBody
          bodySize="small"
        >
          <Icon
            :icon="$options.pkiGettingStartedCard.helpIcon"
            :scale="1"
          />
          {{ $options.pkiGettingStartedCard.helpText }}
        </ParagraphBody>
      </template>
    </CardCta>
  </Container>
</template>

<script>
import {
  CardCta,
  Container,
  HeadingSmall,
  Icon,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { ItemTypeConsts } from 'client/util/Constants';
import { pkiGettingStartedCard } from 'client/Pki/Constants';
import GettingStartedPanel from 'client/components/GettingStartedPanel/GettingStartedPanel.vue';

const { pki } = ItemTypeConsts;

export default {
  name: 'PkiGettingStarted',

  itemType: pki,
  pkiGettingStartedCard,

  components: {
    CardCta,
    Container,
    HeadingSmall,
    GettingStartedPanel,
    Icon,
    ParagraphBody,
  },

  props: {

  },

};
</script>

<style module>
.container {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.card {
  margin-top: var(--jc-spacer);
  max-width: 40ch;
}

.cardHeading {
  border-bottom: var(--jc-border);
  padding-bottom: var(--jc-spacer-small);
}
</style>
